import { RootRoute } from "#src/routes/root";
import { RoutePath } from "#src/utils/route";

export const CalculationsRoutePath = RootRoute.concat(
  new RoutePath({
    path: "/calculations",
    title: "Calculations",
    isPresentational: true,
  })
);
